export const Roles = {
  StaffHR: 'Staff HR',
  ManagerHR: 'Manager HR',
  ManagerSalesOnline: 'Manager Sales Online',
  ManagerSalesOffline: 'Manager Sales Offline',
  ManagerWarehouse: 'Manager Warehouse',
  ManagerProduksi: 'Manager Produksi',
  ManagerMarketingBranding: 'Manager Marketing Branding',
  AssistantDirector: 'Assistant Director',
  Director: 'Director',
}
